<app-loading-spinner *ngIf="loading"></app-loading-spinner>

<div class="flex flex-row items-center gap-5 font-semibold text[#424242] dark:text-white mb-4 mr-5 ml-0 cursor-pointer">
  <p (click)="navigateToProdurement()">Procurement</p>
  <!-- <p onclick="history.back()">Officer Reports</p> -->
  <p onclick="history.back()">Redefine Orders</p>
  <p>View Order</p>
</div>

<div class="w-full min-w-0 bg-white dark:bg-[#363636] shadow-lg rounded-lg">
  <!-- Header -->
  <div class="flex flex-wrap items-center justify-between gap-4 p-4 border-b border-gray-200 dark:border-gray-700">
    <div class="flex flex-wrap items-center gap-6 min-w-0">
      <!-- Invoice Number (outside loop) -->
      <div class="text-sm">
        <div class="text-gray-700 dark:text-gray-300">INV No :</div>
        <div class="font-semibold text-gray-900 dark:text-gray-300" *ngIf="orderdetailsArr?.length">
          {{ orderdetailsArr[0]!.invNo || "N/A" }}
        </div>
      </div>

      <!-- Combined Product Price -->
      <div class="text-sm">
        <div class="text-gray-700 dark:text-gray-300">
          Price of Products :
        </div>
        <div class="font-semibold text-gray-900 dark:text-gray-100">
          Rs. {{ this.totalPackagePrice | number : "1.2-2" }}
        </div>
      </div>

      <!-- Additional Items (outside loop) -->
      <div class="text-sm flex flex-col justify-center items-center">
        <div class="text-gray-700 dark:text-gray-300">Additional Items :</div>
        <button class="w-5 h-5 text-blue-500 hover:text-blue-700"
          (click)="additionalItemsCount !== 0 && openAdditionalItemsModal()"
          [class.opacity-50]="additionalItemsCount === 0">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3 14C3 9.02944 7.02944 5 12 5C16.9706 5 21 9.02944 21 14M17 14C17 16.7614 14.7614 19 12 19C9.23858 19 7 16.7614 7 14C7 11.2386 9.23858 9 12 9C14.7614 9 17 11.2386 17 14Z"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>

      <div class="text-sm flex flex-col justify-center items-center">
        <div class="text-gray-700 dark:text-gray-300 ">
          Excluded Items :
        </div>
        <button class="w-5 h-5 text-blue-500 hover:text-blue-700 transition-opacity"
          [class.opacity-50]="excludedItemsCount === 0" (click)="excludedItemsCount !== 0 && openExcludedItemsModal()">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3 14C3 9.02944 7.02944 5 12 5C16.9706 5 21 9.02944 21 14M17 14C17 16.7614 14.7614 19 12 19C9.23858 19 7 16.7614 7 14C7 11.2386 9.23858 9 12 9C14.7614 9 17 11.2386 17 14Z"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>
    </div>

    <div class="flex shrink-0 space-x-2">
      <button class="px-4 py-2 bg-[#74788D] text-[#D3D3D3] rounded-lg text-sm" (click)="confirmClear()">
        Cancel
      </button>
      <button class="px-4 py-2 e rounded-lg text-sm" [disabled]="!isWithinLimit" [class.opacity-50]="!isWithinLimit"
        [class.cursor-not-allowed]="!isWithinLimit" (click)="confirmComplete()" [ngClass]="{
          'bg-[#415CFF] text-white': isWithinLimit,
          'bg-[#F6F7F9] text-[#6B7D8C] border border-[#6B7D8C]': !isWithinLimit
        }">
        Dispatch
      </button>
    </div>
  </div>
  <span *ngFor="let package of orderdetailsArr">
    <div class="p-4 sm:p-10 space-y-4">
      <div>
        <div class="bg-[#F1F4F5] dark:bg-[#292929] flex items-center justify-between mb-3 p-4 rounded-xl">
          <span class="font-[500] text-[#000000] dark:text-gray-100">
            Package : {{ package.displayName }} (Rs. {{ package.productPrice | number : "1.2-2"}}) <span
              class="text-[#3980C0] text-lg mx-3">(x{{package.packageQty}})</span>
          </span>
          <button (click)="OpenAddNewItemPopUp(package.packageId)"
            class="w-6 h-6 shrink-0 bg-black dark:bg-white text-white dark:text-black flex items-center justify-center">
            <span class="text-sm font-bold">+</span>
          </button>
        </div>
        <div class="space-y-3">
          <span *ngFor="let item of package.items">
            <div class="flex flex-wrap items-center gap-3 border-b-2 py-4 px-5">
              <div class="w-8 shrink-0 text-sm text-gray-700 dark:text-white">
                {{ item.productTypeShortCode }}
              </div>

              <app-searchable-dropdown [items]="getMarketplaceDropdownItems(item.productTypeId)"
                [customStyles]="item.isExcluded === true ? 'border-red-500 text-red-600 bg-red-50' : ''"
                placeholder="--Select Product--" searchPlaceholder="Search products..."
                [ngModel]="getProductValue(item)" (ngModelChange)="onProductSelectionChange($event, item)"
                [clearable]="true" [showSelected]="true" [disabled]="false" [showClearIcon]="false"
                class="flex-1 min-w-0 basis-full sm:basis-48"></app-searchable-dropdown>

              <input type="number" step="0.01" min="0" placeholder="--Quantity in kg--"
                class="rounded-xl dark:bg-[#292929] w-36 shrink-0 px-4 py-3 border border-gray-300 dark:border-gray-600 bg-white text-gray-500 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 text-sm"
                [(ngModel)]="item.qty" (change)="validateQuantity(item)" (keydown)="preventNegativeInput($event)" />
              <div class="w-28 shrink-0 text-right text-sm text-gray-900 dark:text-gray-100">
                Rs. {{ item.price | number : "1.2-2" }}
              </div>

            </div>
          </span>
          <div class="mt-3 flex justify-end px-10">
            <div class="text-sm text-gray-900 dark:text-gray-100">
              Package Total :
              <span class="ml-2">Rs. {{ package.definePkgPrice | number : "1.2-2" }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </span>

  <!-- Combined Grand Total -->
  <div class="px-10 pb-4 border-t border-gray-200 dark:border-gray-700 pt-4">
    <div class="flex justify-end space-x-8">
      <div class="text-right">
        <div class="text-sm text-gray-900 dark:text-gray-100 mb-1">
          Grand Total :
          <span class="ml-2">Rs. {{ this.totalDefinePkgPrice | number : "1.2-2" }}</span>
        </div>
        <div *ngIf="isWithinLimit" class="text-xs text-[#006C5A] italic">
          {{limitMassage}}
        </div>
        <div *ngIf="!isWithinLimit" class="text-xs text-[#E11E21] dark:text-red-400 mt-1 italic">
          {{limitMassage}}
        </div>
      </div>
    </div>
  </div>
</div>


<div *ngIf="showAdditionalItemsModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  (click)="closeAdditionalItemsModal()">
  <div class="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-[500px] max-w-md mx-4 max-h-[90vh] flex flex-col"
    (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="px-6 py-4 text-center shrink-0 dark:border-gray-700">
      <h3 class="text-lg font-semibold text-[#000000] dark:text-gray-100">
        Additional Items
      </h3>
    </div>

    <!-- Modal Content with Scroll -->
    <div
      class="flex-1 overflow-hidden flex flex-col scrollbar-thumb-scrollBarColor scrollbar-track-transparent scrollbar-thumb-rounded-full">
      <!-- Table Header (Fixed) -->
      <div class="shrink-0 px-6 pt-4 pb-2">
        <div
          class="flex justify-between items-center text-sm font-medium text-[#8492A3] dark:text-gray-400 uppercase tracking-wide border-b border-gray-100 dark:border-gray-700 pb-2">
          <div class="w-12 text-center">NO ({{ additionalItemsCount }})</div>
          <div class="flex-1 pl-4">Item</div>
          <div class="w-16 text-center">Qty</div>
          <div class="w-16 text-center">Unit</div>
        </div>
      </div>

      <!-- Scrollable Items List -->
      <div class="flex-1 overflow-y-auto px-6 pb-4">
        <div class="space-y-2">
          <div *ngFor="let item of additionalItems; let i = index"
            class="flex justify-between items-center py-2 dark:border-gray-700">
            <div class="w-12 text-center text-sm text-[#212121] dark:text-gray-100">
              {{ i + 1 }}
            </div>
            <div class="flex-1 text-sm text-[#212121] dark:text-gray-100 truncate pl-4">
              {{ item.displayName }}
            </div>
            <div class="w-16 text-center text-sm text-[#000000] dark:text-gray-100">
              {{ item.qty }}
            </div>
            <div class="w-16 text-center text-sm text-[#808080] dark:text-gray-400">
              {{ item.unit }}
            </div>
          </div>

          <!-- Empty State -->
          <div *ngIf="additionalItems.length === 0" class="text-center py-8 text-gray-400 dark:text-gray-500">
            No additional items
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="px-6 py-4 flex justify-center shrink-0 dark:border-gray-700">
      <button type="button"
        class="px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white rounded-md text-sm font-medium transition-colors"
        (click)="closeAdditionalItemsModal()">
        Cancel
      </button>
    </div>
  </div>
</div>


<div *ngIf="showExcludedItemsModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  (click)="closeExcludedItemsModal()">
  <div class="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-96 max-w-md mx-4 max-h-[90vh] flex flex-col"
    (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="px-6 py-4 text-center shrink-0 dark:border-gray-700">
      <h3 class="text-lg font-semibold text-[#000000] dark:text-gray-100">
        Excluded List Items
      </h3>
    </div>

    <!-- Modal Content -->
    <div class="flex-1 overflow-hidden flex flex-col">
      <!-- Table Header (Fixed) -->
      <div class="shrink-0 px-6 pt-4">
        <div
          class="flex text-sm font-medium text-[#8492A3] dark:text-gray-400 uppercase tracking-wide border-b border-gray-200 dark:border-gray-700 pb-2">
          <div class="w-16 text-center">NO ({{ excludedItemsCount }})</div>
          <div class="flex-1 text-left pl-4">Item Name</div>
        </div>
      </div>

      <!-- Scrollable Table Body -->
      <div
        class="flex-1 overflow-y-auto px-6 pb-4 scrollbar-thumb-scrollBarColor scrollbar-track-transparent scrollbar-thumb-rounded-full">
        <div class="space-y-2">
          <div *ngFor="let item of excludeItemsArr; let i = index"
            class="flex items-center py-2 dark:border-gray-700">
            <div class="w-16 text-center text-gray-600 dark:text-gray-300">{{ i + 1 }}</div>
            <div class="flex-1 text-left pl-4 text-gray-800 dark:text-gray-100 truncate">
              {{ item.displayName }}
            </div>
          </div>

          <!-- Empty State -->
          <div *ngIf="excludeItemsArr.length === 0" class="text-center py-8 text-gray-400 dark:text-gray-500">
            No excluded items
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="px-6 py-4 flex justify-center shrink-0 dark:border-gray-700">
      <button type="button"
        class="px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white rounded-md text-sm font-medium transition-colors"
        (click)="closeExcludedItemsModal()">
        Cancel
      </button>
    </div>
  </div>
</div>

    <div *ngIf="isNewAddPopUp" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      (click)="closeAddNewItemPopUp()">
      <div class="bg-white dark:bg-[#363636]  rounded-lg shadow-xl w-1/3 max-w-md mx-4"
        (click)="$event.stopPropagation()">
        <!-- Modal Header -->
        <div class="px-6 py-4 text-center">
          <h3 class="text-lg font-semibold text-[#000000] dark:text-gray-100">
            Select Category
          </h3>
        </div>

        <div class="flex justify-center">
          <app-searchable-dropdown [items]="categoryDropdownItems" placeholder="Select Category"
            searchPlaceholder="Search categories..." [(ngModel)]="selectCategoryId"
            (selectionChange)="onCategorySelectionChange($event)" [clearable]="true" [showSelected]="true"
            [disabled]="false" class="w-96 mb-4"></app-searchable-dropdown>
        </div>

        <!-- Modal Footer -->
        <div class="px-6 py-4 flex flex-row justify-center gap-x-4">
          <button type="button"
            class="px-4 py-2 bg-[#74788D] text-[#D3D3D3] rounded-md text-sm font-medium transition-colors"
            (click)="closeAddNewItemPopUp()">
            Cancel
          </button>
          <button type="button"
            class="px-6 py-2 bg-[#415CFF] text-white rounded-md text-sm font-medium transition-colors"
            (click)="addNewItems()">
            Add
          </button>
        </div>
      </div>
    </div>
